import { render, staticRenderFns } from "./SubLocationModal.vue?vue&type=template&id=4c8c70b6&"
import script from "./SubLocationModal.vue?vue&type=script&lang=js&"
export * from "./SubLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports